import { IData } from '@hooks/useData';
import IFatura from '@model/Fatura';
import React from 'react';
import { FichaVendedorInadimplentesTable } from './Table';

export type FichaVendedorInadimplentesProps = {
    data: IData<IFatura>
    isLoading: boolean
}

export function FichaVendedorInadimplentes ({ data, isLoading}: FichaVendedorInadimplentesProps) {

    return (
        <FichaVendedorInadimplentesTable
            data={data}
            isLoading={isLoading}
        />
    )
}